import gql from 'graphql-tag';

export const APPLICATION_USER_DATA = gql`
  query applicationUserData {
    currentUser {
      id
      name
      locale
      currentUnit {
        id
        name
        country {
          code
        }
      }
      permissions {
        canAssignRole
        canAdminUnitEntities
        canSendSellerInvoice
        canUpdateProducts
        canCreatePaychecks
        canCreateAdvancedPaychecks
        canSendAltinnPaycheckReports
        canEditEmployees
        canUpdateUnit
        isSuperAdmin
        canDoAccountingLvl1
        canDoAccountingLvl2
      }
    }
  }
`;

export const CURRENT_UNIT = gql`
  query currentUnit {
    currentUnit {
      id
      name
      locale
      country {
        code
      }
    }
  }
`;
